import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step11 } from '../../../../shared/models/component-messages/mapaIN/step11';
import { InfosSup } from '../models/InfosSup';
@Component({
  selector: 'app-infos-sup',
  templateUrl: './infos-sup.component.html'
})
export class InfosSupComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'InfosSup';
  @Input() parentForm: FormGroup;
	@Input() disabled: boolean;
	
	@Input() infosSup: InfosSup;

  public step11 = new Step11();

  constructor() { }

  public ngOnInit() {
  }
  
  
  
  
  
  

  
  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }
  
  
}

